<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary"><span :onload="fullName">{{ full_name }}</span></router-link>
  </div>
</template>

<script>
export default {
  name: "CellRendererName",
  data() {
    return {
      full_name: null
    };
  },
  computed: {
    url () {
      // return '/apps/user/user-view/268'

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      return `/user/trainee-list/user-edit/${ this.params.data.id}`
    },
    fullName() {
      // console.log("params", this.params)
      if (this.params.data.firstName !== null && this.params.data.firstName !== undefined)
        this.full_name = this.params.data.firstName
          .concat(" ")
          .concat(this.params.data.lastName);
    }
  }
};
</script>

<style lang="scss" scoped></style>
